export default {
  it: {
    quoteDetails: "Dettaglio Preventivo",
    client: "Cliente",
    operator: "Operatore",
    date: "Data",
    eventName: "Nome Evento",
    location: "Luogo",
    itemsList: "Elenco Articoli",
    areas: "Zone",
    name: "Nome",
    item: "Articolo",
    quantity: "Quantità",
    price: "Prezzo",
    category: "Categoria",
    noData: "N/D",
    noItemsMessage: "Nessun articolo presente nel preventivo",
    generalArea: "Generale",
    signature: "Firma",
    total: "Totale",
    paymentDetails: "Dati pagamento",
    iban: "IBAN",
    payableTo: "Intestato a",
    instruments: "Strumenti",
    vat: "IVA",
    other: "Altro",
    quote: "preventivo",
  },
  en: {
    quoteDetails: "Quote Details",
    client: "Client",
    operator: "Operator",
    date: "Date",
    eventName: "Event Name",
    location: "Location",
    itemsList: "Articles List",
    areas: "Areas",
    name: "Name",
    item: "Item",
    quantity: "Quantity",
    price: "Price",
    category: "Category",
    noData: "N/A",
    noItemsMessage: "No items in the quote",
    generalArea: "General",
    signature: "Signature",
    total: "Total",
    paymentDetails: "Payment Details",
    iban: "IBAN",
    payableTo: "Payable to",
    instruments: "Instruments",
    vat: "VAT",
    other: "Other",
    quote: "quote",
  },
};
